module.exports = __webpack_public_path__ + "static/media/tip5.24010265.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Confirmation/img/tips/tip5.jpg
// module id = 976
// module chunks = 0